<template>
  <!--Check if detailedRace exists before rendering form-->
  <div v-if="detailedRaceAvailable">
    <div class="raceWrapper">
      <!--Nav bar is only on web version of FormGuide-->
      <RunnerNavBar v-if="!isMobile" :runnerData="detailedRace" />
      <!--Web components-->
      <v-main v-if="!isMobile">
        <RaceName
          v-if="typeof featureToggle[bookie].raceName === 'undefined'"
          :raceComment="detailedRace.comment"
          :raceFlucs="detailedRace"
        />
        <RunnerComments
          v-if="typeof featureToggle[bookie].raceOverview === 'undefined'"
          :raceComment="getRunnerComment(detailedRace.comments)"
          :raceFlucs="detailedRace"
        />
        <RaceField
          v-if="typeof featureToggle[bookie].raceField === 'undefined'"
          :raceFlucs="detailedRace"
          :formAvailable="checkForForm(detailedRace)"
        />
        <div class="runnerList">
          <RunnersList
            v-if="typeof featureToggle[bookie].runnersList === 'undefined'"
            :formAvailable="checkForForm(detailedRace)"
          />
        </div>
      </v-main>
      <!--Mobile components-->
      <v-main v-if="isMobile">
        <div id="mobileContainer">
          <RaceNameMobile
            v-if="typeof featureToggle[bookie].raceName === 'undefined'"
            :raceComment="detailedRace.comment"
            :raceFlucs="detailedRace"
          />
          <RunnerCommentsMobile
            v-if="typeof featureToggle[bookie].raceOverview === 'undefined'"
            :raceComment="getRunnerComment(detailedRace.comments)"
            :raceFlucs="detailedRace"
          />
          <RaceFieldMobile
            v-if="typeof featureToggle[bookie].raceField === 'undefined'"
            :raceFlucs="detailedRace"
            :formAvailable="checkForForm(detailedRace)"
          />
        </div>
        <!--Mobile runner navigation dropdown-->
        <div id="runnerMenu" class="show">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primaryCol"
                dark
                v-bind="attrs"
                v-on="on"
                small
              >
                Runners
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list color="grey" class="lighten-3">
              <v-list-item
                v-for="(runner, index) in sortRunners(detailedRace.competitors).filter(e => !e.scratched)"
                :key="index"
              >
                <v-btn @click="scrollToRunner(runner)" color="white" elevation="2" style="padding: 0">
                  <v-list-item-title style="cursor: pointer; max-width: 35px" class="text-left ml-2">
                    <v-btn
                      @click="scrollToRunner(d.tabNo)"
                      outlined
                      class="font-weight-bold caption mr-1"
                      fab
                      x-small
                      color="white"
                      style="cursor:pointer;"
                    >{{runner.tabNo}}</v-btn>
                  </v-list-item-title>
                  <v-list-item-icon class="mr-2 ml-2" style="margin-left: 0;">
                    <img v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'" :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+runner.tabNo+'_64x64.png'" alt="jockey silks" height = "32">
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && runner.tabNo" style="width:28px;overflow:hidden;" :class="['greyhoundSpriteUk-' + runner.tabNo]" />
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && runner.tabNo" style="width:28px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + runner.tabNo]" />
                    <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && runner.tabNo" style="width:28px;overflow:hidden;" :class="['greyhoundSpriteUs-' + runner.tabNo]" />
                  </v-list-item-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="runnerListMobile">
          <RunnersListMobile
            v-if="typeof featureToggle[bookie].runnersList === 'undefined'"
            :formAvailable="checkForForm(detailedRace)"
          />
        </div>
      </v-main>
    </div>
  </div>
</template>

<script>
import RaceName from './RaceName.vue'
import RaceNameMobile from './RaceNameMobile'
import RunnersList from '@/components/RunnersList'
import RunnersListMobile from './RunnersListMobile'
import RunnerNavBar from '@/components/RunnerNavBar'
import RunnerComments from '@/components/RunnerComments'
import RunnerCommentsMobile from './RunnerCommentsMobile'
import RaceField from '@/components/RaceField'
import RaceFieldMobile from './RaceFieldMobile'
import { featureToggle } from '../common/config'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'Form',
  components: {
    RaceName,
    RaceNameMobile,
    RunnersList,
    RunnersListMobile,
    RunnerNavBar,
    RaceField,
    RaceFieldMobile,
    RunnerComments,
    RunnerCommentsMobile
  },
  data () {
    return {
      cssPath: process.env.BASE_URL + 'stylesheets/' + window.location.host.split('.')[0] + '.css',
      logoPath: process.env.BASE_URL + 'logos/' + window.location.host.split('.')[0] + '.png',
      favIconPath: process.env.BASE_URL + 'favicons/' + window.location.host.split('.')[0] + '.png',
      imageSrcs: '~@/assets/DO_BookieLogosSprite_icons.png',
      featureToggle
    }
  },
  created: function () {
    localStorage.clear()
    this.setStoreVariables()
    this.getUrlParam()
    this.getFavicon()
    this.fetchRace()
    window.resizeTo(1320, window.screen.availHeight)
    this.preloadImage(this.imageSrcs)
  },
  computed: {
    ...mapState(['raceID', 'detailedRace', 'gbsID', 'bookie']),
    ...mapGetters(['hasFeature', 'isMobile']),
    detailedRaceAvailable () {
      return Object.keys(this.detailedRace)?.length > 0
    }
  },
  methods: {
    ...mapActions(['setRouterVariables', 'setBestPriceBookies', 'setRaceID', 'fetchRace', 'subscribePrices']),
    preloadImage (url) {
      const img = new Image()
      img.src = url
    },
    sortRunners (data) {
      return data.slice().sort((a, b) => a.tabNo - b.tabNo)
    },
    scrollToRunner (runner) {
      window.location.href = `#${runner.tabNo}`
    },
    setStoreVariables () {
      const varObj = {
        gbsID: this.$route.params.id,
        raceNo: this.$route.params.raceNo,
        runnerNo: this.$route.params.runnerNo
      }
      this.setRouterVariables(varObj)
      // Get DO Bookies and set in state
      if (window.location.host.split('.')[0] === 'do') {
        const urlParameters = window.location.search
        const urlParams = new URLSearchParams(urlParameters)
        const codes = urlParams.get('codes')
        if (codes) {
          this.setBestPriceBookies(codes?.split(','))
        }
      }
    },
    getRunnerComment (comments) {
      const filteredComments = comments?.filter(b => b.source !== 'RAS')
      return filteredComments[0]?.comment || ''
    },
    checkForForm (data) {
      if (data.competitors) {
        let formAvailable = 0
        // eslint-disable-next-line array-callback-return
        data.competitors.forEach((b) => {
          if (b.formHistory.length > 0) {
            formAvailable += 1
          }
        })
        return formAvailable !== 0
      }
    },
    getUrlParam () {
      const file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = this.cssPath
      document.head.appendChild(file)
    },
    getFavicon () {
      if (this.bookie === 'betmakers') {
        const file = document.createElement('link')
        file.rel = 'icon'
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          file.href = '../favicon_dark.ico'
          document.head.appendChild(file)
        } else {
          file.href = '../favicon.ico'
          document.head.appendChild(file)
        }
      } else {
        const file = document.createElement('link')
        file.rel = 'icon'
        file.href = this.favIconPath
        document.head.appendChild(file)
      }
    }
  }
}
</script>

<style scoped>
.v-list {
  max-height: 85vh;
  overflow-y: auto;
}
#runnerMenu {
  position: fixed;
  top: 78px;
  left: calc(100% - 110px);
  z-index: 999999;
}
.runnerList {
  width:1024px;
}
.runnerListMobile {
}
.hide {
  opacity: 0;
  left: -100%;
}
.show {
  opacity: 1;
  left: 0;
}
/* UK Greys */
.greyhoundSpriteUk-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUk-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUk-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUk-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUk-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUk-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUk-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUk-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -196px;
}
/* AUS Greys */
.greyhoundSpriteAUS-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteAUS-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteAUS-3 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteAUS-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteAUS-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteAUS-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteAUS-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteAUS-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteAUS-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteAUS-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -252px;
}
/* US Greys */
.greyhoundSpriteUs-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUs-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUs-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUs-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUs-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUs-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUs-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUs-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteUs-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteUs-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -252px;
}
</style>
